import './imports';
import './polyfill';

// Libraries
import Vue from './imports/vue';

// App
import router from './routes';
import store from './store';
import preloader from './services/Preloader';
import Auth from './services/Auth';

import App from './components/App.vue';
const AppConstructor = Vue.extend(App);

window.$vm = new AppConstructor({ 
    router,
    store: store,
    mounted: function() {
        new preloader().preload();
    },
    created: function() {
        let uri = window.location.href.replace('#/', '').split('?');
        if (uri.length == 2) {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function(v) {
                tmp = v.split('=');
                if(tmp.length == 2)
                getVars[tmp[0]] = tmp[1];
            });
            
            if (getVars['previewMode'] && getVars['previewMode'] == 'enabled') {                

                Auth.loginToken(getVars['token']).then(() => {

                    this.$mia.preview.api.init('*', (data) => {

                        if (data.key == 1001) {
                            data.assignmentCode = "assessment";
                        }

                        if (!data.assignmentCode) return;

                        this.$router.replace({ 
                            name: 'miapreview', 
                            params: {
                                code: data.assignmentCode,
                                index: data.questionIndex
                            }
                        })
                    });
                });
            }
        }
    },
}).$mount('#app');